import { Guid, Nillable } from '@web/utils';

export class AdminSubscriptionsToProcessDetails {
  public constructor(
    private readonly data: {
      isBulkProcessAvailable: boolean;
      itemsToProcess: number;
      nextScheduledProcessingDate: Date;
      soldBoxId: Nillable<Guid>;
      soldBoxName: Nillable<string>;
    },
  ) {}

  public get isBulkProcessAvailable(): boolean {
    return this.data.isBulkProcessAvailable;
  }

  public get itemsToProcess(): number {
    return this.data.itemsToProcess;
  }

  public get nextScheduledProcessingDate(): Date {
    return this.data.nextScheduledProcessingDate;
  }

  public get soldBoxId(): Nillable<Guid> {
    return this.data.soldBoxId;
  }

  public get soldBoxName(): Nillable<string> {
    return this.data.soldBoxName;
  }
}
